module.exports = __webpack_public_path__ + "img/CM-KT-24-Mazda-Playful.0119924d.jpg";